export default __webpack_public_path__ + "static/media/adithya.a78e3917.jpg";